import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';

export class TrailersList extends Component {
  static defaultProps = {
    multiSelectable: true,
    isAdmin: false,
    voidOrder: () => {}
  }
  static propTypes = {
    dataProvider: PropTypes.array.isRequired,
    onRowSelection: PropTypes.func,
    multiSelectable: PropTypes.bool,
  }

  constructor(props) {
    super(props);

    this.onRowSelection = this.onRowSelection.bind(this);

    this.state = {
      open: false,
    };
  }

  onRowSelection(values) {
    const { dataProvider, onRowSelection } = this.props;
    let vals = [];
    if (values === "all") {
      vals = dataProvider.map(item => item.id);
    } else if (values && values !== "none") {
      vals = values.map(item => _.nth(dataProvider, item).id);
    }

    if (onRowSelection) {
      onRowSelection(vals);
    }
  }

  render() {
    const { dataProvider, multiSelectable } = this.props;
    const content = dataProvider.map(item => {
        const { id, name } = item;
        return (<TableRow key={id}>
          <TableRowColumn>{name}</TableRowColumn>
        </TableRow>);
      });

    return (
      <div>
        <Table multiSelectable={multiSelectable} onRowSelection={this.onRowSelection}>
          <TableHeader>
            <TableRow>
              <TableHeaderColumn>Name</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody deselectOnClickaway={false}>
            { content }
          </TableBody>
        </Table>
      </div>
    );
  }
}

export default TrailersList;


// WEBPACK FOOTER //
// ./src/components/Fleet/Trailers/List.js